import { render, staticRenderFns } from "./audioIcon.vue?vue&type=template&id=0a83e3da&"
import script from "./audioIcon.vue?vue&type=script&lang=js&"
export * from "./audioIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports